define('modules/module.blank',['jquery', './module', 'Handlebars'], function ($, Module, Handlebars) {
  var BlankModule = Module.extend({
    template: Handlebars.compile(''),
  }, {
    configurable: false,
  })

  return BlankModule;
});

